import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PaymentTypeSelect } from "../PaymentTypeSelect";
import { CreditCardForm } from "../CreditCardForm";
import { BankAccountForm } from "../BankAccountForm";
import { PaymentType, PaymentFormData } from "@/types/payment";

interface PaymentFormContainerProps {
  isLoading: boolean;
  onSubmit: (data: PaymentFormData) => Promise<void>;
  onCancel: () => void;
}

export const PaymentFormContainer = ({
  isLoading,
  onSubmit,
  onCancel,
}: PaymentFormContainerProps) => {
  const [paymentType, setPaymentType] = useState<PaymentType>("credit");
  const [formData, setFormData] = useState<PaymentFormData>({
    cardNumber: "",
    bankNumber: "",
    cardExpiry: "",
    cardCvv: "",
  });

  const handleSubmit = async () => {
    await onSubmit(formData);
  };

  return (
    <Card className="p-6">
      <div className="space-y-6">
        <h3 className="text-lg font-medium">Add Payment Method</h3>
        
        <PaymentTypeSelect 
          value={paymentType}
          onValueChange={setPaymentType}
        />

        {paymentType === "credit" ? (
          <CreditCardForm
            cardNumber={formData.cardNumber}
            cardExpiry={formData.cardExpiry}
            cardCvv={formData.cardCvv}
            onCardNumberChange={(value) => setFormData(prev => ({ ...prev, cardNumber: value }))}
            onCardExpiryChange={(value) => setFormData(prev => ({ ...prev, cardExpiry: value }))}
            onCardCvvChange={(value) => setFormData(prev => ({ ...prev, cardCvv: value }))}
          />
        ) : (
          <BankAccountForm
            bankNumber={formData.bankNumber}
            onBankNumberChange={(value) => setFormData(prev => ({ ...prev, bankNumber: value }))}
          />
        )}

        <div className="flex gap-4">
          <Button
            onClick={onCancel}
            variant="outline"
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={isLoading}
            className="flex-1 bg-primary text-white hover:bg-primary/90"
          >
            {isLoading ? "Saving..." : "Save Payment Method"}
          </Button>
        </div>
      </div>
    </Card>
  );
};